import type { EntityAdminRecord } from '@src/components/EntityAdmin/types';
import { type DurationInputProps, DurationInput } from '@src/components/Form/DurationInput/DurationInput';
import type { Paths } from '@src/utils/types';
import { get } from 'lodash-es';
import type { CustomDrawerContentRenderProps } from './registry';

interface DurationInputContentProps<TRecord extends EntityAdminRecord>
  extends
    CustomDrawerContentRenderProps<TRecord, any>,
    Pick<DurationInputProps, 'timeRangeUnits' | 'prefix' | 'placeholder' | 'disabled' | 'dataTestId' | 'defaultUnit'> {
  /** Entity Admin Record field name - supports nested paths */
  fieldName: Paths<TRecord>;
  /** Default value to use if the field value is undefined or empty */
  defaultValue?: string;
}

/** DurationInput component inside of EntityAdmin drawer */
export const DurationInputContent = <TRecord extends EntityAdminRecord>({
  form,
  onFormUpdate,
  fieldName,
  prefix,
  placeholder,
  timeRangeUnits,
  disabled,
  defaultValue,
  defaultUnit,
}: DurationInputContentProps<TRecord>) => {
  // TODO - add duration to registerDrawerContentRenderer, but it's usable for now
  const formValue = get(form, fieldName) as string | undefined;
  const initialValue = formValue ?? defaultValue;
  return (
    <DurationInput
      initialValue={initialValue}
      onChange={value => onFormUpdate(fieldName, value)}
      hideTermSelector={true}
      prefix={prefix}
      timeRangeUnits={timeRangeUnits}
      defaultUnit={defaultUnit}
      placeholder={placeholder || 'Enter custom term'}
      disabled={disabled}
      dataTestId={`entity-admin-drawer-${fieldName}`}
    />
  );
};
